export default {
  title: "Account",
  subtitle: "Gestisci le informazioni del tuo account",
  description: "Gestisci le impostazioni del tuo account",
  profile: {
    title: "Profilo",
    completeProfile: "Completa profilo",
    defaultName: "Ospite",
    noProfile: "Nessun profilo",
    errors: {
      loadProfile: "Errore nel caricamento del profilo",
      saveProfile: "Errore nel salvataggio del profilo"
    },
    weddingInfo: {
      title: "Informazioni sul matrimonio",
      partner1: "Partner 1",
      partner2: "Partner 2",
      date: "Data",
      location: "Luogo",
      expectedGuests: "Ospiti previsti",
      notes: "Note"
    }
  },
  settings: {
    title: "Impostazioni",
    loadError: "Errore nel caricamento delle impostazioni",
    saveError: "Errore nel salvataggio delle impostazioni",
    saveSuccess: "Impostazioni salvate con successo"
  },
  security: "Sicurezza",
  notifications: "Notifiche",
  profilePhoto: "Foto profilo",
  changePhoto: "Cambia foto",
  photoRequirements: "JPG, PNG o GIF, max 2MB",
  deletePhoto: "Elimina foto",
  saveChanges: "Salva modifiche",
  twoFactorAuth: "Autenticazione a due fattori",
  linkedAccounts: "Account collegati",
  dataExport: "Esporta dati",
  subscription: {
    title: "Abbonamento",
    currentPlan: "Piano attuale",
    free: "Gratuito",
    essential: "Essenziale",
    pro: "Pro",
    manage: "Gestisci abbonamento",
    viewPlans: "Vedi piani",
    upgrade: "Aggiorna piano",
    eventsUsed: "Eventi utilizzati",
    limits: {
      maxGuests: "Ospiti max",
      maxTasks: "Attività max",
      maxVendors: "Fornitori max",
      maxEvents: "Eventi max"
    },
    features: {
      unlimitedEvents: "Eventi illimitati",
      unlimitedGuests: "Ospiti illimitati",
      export: "Esportazione PDF ed Excel",
      budget: "Budget e Analisi",
      seating: "Piano dei posti",
      support: "Supporto prioritario"
    },
    plans: {
      free: {
        name: "Gratuito"
      },
      essential: {
        name: "Essenziale"
      },
      premium: {
        name: "Premium"
      },
      pro: {
        name: "Pro"
      }
    }
  },
  limits: {
    title: "Limiti",
    maxGuests: "Ospiti massimi",
    maxTasks: "Attività massime",
    maxVendors: "Fornitori massimi",
    maxCollaborators: "Collaboratori massimi"
  },
  form: {
    firstName: "Nome",
    lastName: "Cognome",
    email: "Email",
    phone: "Telefono",
    address: "Indirizzo",
    city: "Città",
    country: "Paese",
    timezone: "Fuso orario",
    language: "Lingua",
    avatar: "Avatar"
  },
  actions: {
    save: "Salva",
    cancel: "Annulla",
    edit: "Modifica",
    delete: "Elimina account",
    changePassword: "Cambia password",
    uploadAvatar: "Carica avatar"
  },
  messages: {
    profileUpdated: "Profilo aggiornato con successo",
    passwordChanged: "Password cambiata con successo",
    avatarUploaded: "Avatar caricato con successo",
    accountDeleted: "Account eliminato con successo",
    error: "Si è verificato un errore"
  },
  events: {
    yourEvents: "I tuoi eventi"
  },
  partners: {
    title: "Informazioni del partner",
    partner1: "Partner 1",
    partner2: "Partner 2",
    firstName: "Nome",
    lastName: "Cognome",
    email: "Email",
    save: "Salva"
  },
  pageTitle: "Account | WedBox",
  accountManagement: "Gestione account",
  chooseWhatToManage: "Scegli cosa vuoi gestire",
  myProfile: "Il mio profilo",
  personalPreferences: "Preferenze personali",
  managePersonalInfo: "Gestisci le tue informazioni personali, foto profilo, lingua e preferenze di notifica.",
  accessMyProfile: "Accedi al mio profilo",
  eventSettings: "Impostazioni evento",
  eventTypeSpecific: {
    wedding: {
      subtitle: "Specifico per il tuo matrimonio",
      description: "Gestisci i dettagli del tuo matrimonio, partner, data, collaboratori e statistiche.",
      buttonText: "Impostazioni matrimonio"
    },
    birthday: {
      subtitle: "Specifico per il tuo compleanno",
      description: "Gestisci i dettagli del tuo compleanno, data, collaboratori e statistiche.",
      buttonText: "Impostazioni compleanno"
    },
    "baby-shower": {
      subtitle: "Specifico per il tuo baby shower",
      description: "Gestisci i dettagli del tuo baby shower, data, collaboratori e statistiche.",
      buttonText: "Impostazioni baby shower"
    },
    baptism: {
      subtitle: "Specifico per il tuo battesimo",
      description: "Gestisci i dettagli del tuo battesimo, data, collaboratori e statistiche.",
      buttonText: "Impostazioni battesimo"
    },
    engagement: {
      subtitle: "Specifico per il tuo fidanzamento",
      description: "Gestisci i dettagli del tuo fidanzamento, data, collaboratori e statistiche.",
      buttonText: "Impostazioni fidanzamento"
    },
    default: {
      subtitle: "Specifico per il tuo evento",
      description: "Gestisci i dettagli del tuo evento, data, collaboratori e statistiche.",
      buttonText: "Impostazioni evento"
    }
  },
  improvedOrganization: "📋 Organizzazione migliorata",
  organizationNote: "Abbiamo separato le impostazioni personali dalle impostazioni specifiche dell'evento per una migliore organizzazione. Le tue preferenze utente sono ora in \"Il mio profilo\", mentre tutto ciò che riguarda il tuo evento si trova in \"Impostazioni evento\".",
  subscriptionManagement: "Gestione abbonamenti",
  manageYourPlan: "Gestisci il tuo piano e monitora il tuo utilizzo",
  displayName: "Nome visualizzato",
  phoneNumber: "Numero di telefono",
  yourFullName: "Il tuo nome completo",
  emailAddress: "Indirizzo email",
  emailCannotBeModified: "L'email non può essere modificata per motivi di sicurezza",
  personalInformation: "Informazioni personali",
  languageInterface: "Lingua dell'interfaccia",
  notificationPreferences: "Preferenze di notifica",
  emailNotifications: "Notifiche email",
  receiveEmailNotifications: "Ricevi notifiche email",
  pushNotifications: "Notifiche push",
  receiveBrowserNotifications: "Ricevi notifiche nel browser",
  deleteAccountWarning: "⚠️ Questa azione è irreversibile. Tutti i tuoi dati saranno eliminati permanentemente.",
  permanentlyDeleteAccount: "Elimina permanentemente il mio account",
  languageChangedTo: "Lingua cambiata in {{language}}",
  error: "Errore:",
  saveError: "Puoi aggiungere una notifica di errore qui",
  language: "Lingua",
  languageDescription: "Scegli la lingua di visualizzazione dell'applicazione",
  languageSelect: "Seleziona la tua lingua",
  weddingDetails: "Dettagli del matrimonio",
  weddingDate: "Data del matrimonio",
  partnerInfo: "Informazioni del partner",
  partner1: "Partner 1",
  partner2: "Partner 2",
  firstName: "Nome",
  lastName: "Cognome",
  accessManagement: "Gestione accessi",
  accessManagementDescription: "Gestisci chi può accedere ai dati del tuo matrimonio",
  manageCollaborators: "Gestisci collaboratori",
  loadError: "Errore nel caricamento delle impostazioni",
  saveSuccess: "Impostazioni salvate con successo",
  noData: "Nessun dato disponibile",
  tabs: {
    profile: "Profilo",
    sharing: "Condividi",
    settings: "Impostazioni"
  },
  delete: {
    title: "Elimina account",
    description: "Elimina permanentemente il tuo account e tutti i dati associati",
    confirmTitle: "Sei sicuro?",
    confirmDescription: "Questa azione è irreversibile. Tutti i tuoi dati saranno eliminati permanentemente.",
    confirmButton: "Elimina account",
    gdprNotice: "In conformità con il GDPR, tutti i tuoi dati personali saranno eliminati permanentemente."
  },
  deleteAccount: {
    title: "Elimina account",
    description: "Elimina permanentemente il tuo account e tutti i tuoi dati. Questa azione è irreversibile.",
    warning: "Attenzione: Questa azione è irreversibile e eliminerà permanentemente tutti i tuoi dati.",
    confirm: "Sì, elimina il mio account",
    confirmDescription: "Conferma la tua password per eliminare il tuo account.",
    confirmFacebookDescription: "Sei connesso con Facebook. Per confermare l'eliminazione del tuo account, clicca il pulsante qui sotto.",
    confirmGoogleDescription: "Sei connesso con Google. Per confermare l'eliminazione del tuo account, clicca il pulsante qui sotto.",
    passwordLabel: "Password",
    reasonLabel: "Motivo dell'eliminazione",
    feedbackLabel: "Feedback aggiuntivo",
    reasons: {
      select: "Seleziona un motivo",
      notUseful: "L'applicazione non è utile per me",
      tooComplex: "L'applicazione è troppo complessa",
      foundAlternative: "Ho trovato una migliore alternativa",
      other: "Altro motivo"
    },
    errors: {
      invalidPassword: "Password non corretta",
      reasonRequired: "Seleziona un motivo",
      popupClosed: "La finestra di conferma è stata chiusa",
      authCancelled: "Autenticazione annullata",
      generic: "Si è verificato un errore",
      recentLogin: "Effettua nuovamente il login per eseguire questa azione",
      wrongPassword: "Password errata"
    },
    success: "Account eliminato con successo"
  },
  export: {
    title: "Esporta dati",
    description: "Scarica tutti i tuoi dati in formato JSON",
    button: "Scarica dati",
    loading: "Preparazione download...",
    gdprNotice: "Questa esportazione include tutti i tuoi dati personali in conformità con i requisiti GDPR."
  },
  errors: {
    deleteAccount: "Errore nell'eliminazione dell'account",
    exportData: "Errore nell'esportazione dei dati"
  },
  collaborators: {
    title: "Collaboratori",
    description: "Gestisci le persone che possono aiutarti con la pianificazione del matrimonio",
    count: "{{count}} collaboratori",
    invite: "Invita collaboratore",
    inviteEmail: "Indirizzo email",
    placeholder: "Inserisci indirizzo email",
    role: "Ruolo",
    roles: {
      admin: "Amministratore",
      editor: "Editor",
      viewer: "Visualizzatore"
    },
    roleDescriptions: {
      admin: "Può modificare tutto e gestire collaboratori",
      editor: "Può modificare sezioni selezionate",
      viewer: "Può solo visualizzare sezioni selezionate"
    },
    rolesTitle: "Gestione ruoli",
    accessTo: "Accesso a",
    accessToSections: "Accesso alle sezioni",
    resourceTypes: {
      all: "Tutto",
      tasks: "Attività",
      guests: "Ospiti",
      budget: "Budget",
      timeline: "Cronologia",
      tasks_and_guests: "Attività e Ospiti"
    },
    status: {
      pending: "In sospeso",
      accepted: "Accettato",
      refused: "Rifiutato",
      expired: "Scaduto"
    },
    lastActive: "Ultima attività",
    remove: "Rimuovi collaboratore",
    modifyAccess: "Modifica accesso",
    updateRoleError: "Errore nell'aggiornamento del ruolo",
    inviteSuccess: "Invito inviato con successo",
    inviteError: "Errore nell'invio dell'invito",
    list: "Lista collaboratori",
    empty: "Ancora nessun collaboratore"
  },
  sharing: {
    activeLinksTitle: "Link di condivisione attivi",
    activeLinksDesc: "Questi link consentono l'accesso al tuo evento senza un account utente.",
    accessTo: "Accesso a"
  }
};
